import React from 'react';
import { PropertyPresentationWizard } from '../../components/rental/PropertyPresentationWizard';
export function PropertyPresentation() {
  return <PropertyPresentationWizard data-id="element-10406" />;
}